/**
 * Feature count thresholds for AI Chat layers
 *
 * These thresholds are used to:
 * - Display color-coded indicators in the UI
 * - Warn users about potentially expensive queries
 * - Determine when to show confirmation dialogs
 */

// Warning threshold - show yellow indicator
export const FEATURE_COUNT_WARNING_THRESHOLD = 200

// Critical threshold - show red indicator and confirmation dialog
export const FEATURE_COUNT_CRITICAL_THRESHOLD = 250
